import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NON_EN_LANGS = ["fr", "zh", "zh-TW", "pa", "es", "tl", "ar", "ko", "ja"];

export function useLocalizedPath() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const prefix = NON_EN_LANGS.includes(lang) ? `/${lang}` : "";

  return (path) => `${prefix}${path}`;
}

export function useLocalizedNavigate() {
  const navigate = useNavigate();
  const localizedPath = useLocalizedPath();

  return (path, options) => navigate(localizedPath(path), options);
}
